/*!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
* GRL_MODIFY: Modified from codegen version. GRL_MODIFY marks changes
!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!*/
/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import * as React from "react";
import {
  Button,
  Divider,
  Flex,
  Grid,
  Heading,
  Text,
  TextAreaField,
} from "@aws-amplify/ui-react";
import { BusinessModelChange } from "../models";
import { fetchByPath, getOverrideProps, validateField } from "./utils";
import { DataStore } from "aws-amplify/datastore";
export default function BusinessModelChangeCreateForm(props) {
  const {
    clearOnSuccess = true,
    onSuccess,
    onError,
    onSubmit,
    onValidate,
    onChange,
    overrides,
    presets, // GRL_MODIFY: add presets prop
    ...rest
  } = props;
  const initialValues = {
    CurrentBusinessModelChange: "",
    AnticipatedBusinessModelChange: "",
    ...presets // GRL_MODIFY: add presets to initial values
  };
  const [CurrentBusinessModelChange, setCurrentBusinessModelChange] =
    React.useState(initialValues.CurrentBusinessModelChange);
  const [AnticipatedBusinessModelChange, setAnticipatedBusinessModelChange] =
    React.useState(initialValues.AnticipatedBusinessModelChange);
  const [errors, setErrors] = React.useState({});
  const resetStateValues = () => {
    setCurrentBusinessModelChange(initialValues.CurrentBusinessModelChange);
    setAnticipatedBusinessModelChange(
      initialValues.AnticipatedBusinessModelChange
    );
    setErrors({});
  };
  const validations = {
    CurrentBusinessModelChange: [],
    AnticipatedBusinessModelChange: [],
  };
  const runValidationTasks = async (
    fieldName,
    currentValue,
    getDisplayValue
  ) => {
    const value =
      currentValue && getDisplayValue
        ? getDisplayValue(currentValue)
        : currentValue;
    let validationResponse = validateField(value, validations[fieldName]);
    const customValidator = fetchByPath(onValidate, fieldName);
    if (customValidator) {
      validationResponse = await customValidator(value, validationResponse);
    }
    setErrors((errors) => ({ ...errors, [fieldName]: validationResponse }));
    return validationResponse;
  };
  return (
    <Grid
      as="form"
      rowGap="15px"
      columnGap="15px"
      padding="20px"
      onSubmit={async (event) => {
        event.preventDefault();
        let modelFields = {
          CurrentBusinessModelChange,
          AnticipatedBusinessModelChange,
        };
        const validationResponses = await Promise.all(
          Object.keys(validations).reduce((promises, fieldName) => {
            if (Array.isArray(modelFields[fieldName])) {
              promises.push(
                ...modelFields[fieldName].map((item) =>
                  runValidationTasks(fieldName, item)
                )
              );
              return promises;
            }
            promises.push(
              runValidationTasks(fieldName, modelFields[fieldName])
            );
            return promises;
          }, [])
        );
        if (validationResponses.some((r) => r.hasError)) {
          return;
        }
        if (onSubmit) {
          modelFields = onSubmit(modelFields);
        }
        try {
          Object.entries(modelFields).forEach(([key, value]) => {
            if (typeof value === "string" && value === "") {
              modelFields[key] = null;
            }
          });
          await DataStore.save(new BusinessModelChange(modelFields));
          if (onSuccess) {
            onSuccess(modelFields);
          }
          if (clearOnSuccess) {
            resetStateValues();
          }
        } catch (err) {
          if (onError) {
            onError(modelFields, err.message);
          }
        }
      }}
      {...getOverrideProps(overrides, "BusinessModelChangeCreateForm")}
      {...rest}
    >
      <Heading
        level={4}
        children="Business Model Change"
        {...getOverrideProps(overrides, "SectionalElement0")}
      ></Heading>
      <Heading
        children="IFRS S2 paragraph 14 a i."
        {...getOverrideProps(overrides, "SectionalElement00")}
      ></Heading>
      <Text
        children="Create a record that defines the current and anticipated changes to your business model (including resource allocation), to address your climate-related risks and opportunities."
        {...getOverrideProps(overrides, "SectionalElement1")}
      ></Text>
      <Divider
        orientation="horizontal"
        {...getOverrideProps(overrides, "SectionalElement2")}
      ></Divider>
      <TextAreaField
        label="Current business model change"
        isRequired={false}
        isReadOnly={false}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              CurrentBusinessModelChange: value,
              AnticipatedBusinessModelChange,
            };
            const result = onChange(modelFields);
            value = result?.CurrentBusinessModelChange ?? value;
          }
          if (errors.CurrentBusinessModelChange?.hasError) {
            runValidationTasks("CurrentBusinessModelChange", value);
          }
          setCurrentBusinessModelChange(value);
        }}
        onBlur={() =>
          runValidationTasks(
            "CurrentBusinessModelChange",
            CurrentBusinessModelChange
          )
        }
        errorMessage={errors.CurrentBusinessModelChange?.errorMessage}
        hasError={errors.CurrentBusinessModelChange?.hasError}
        	value={CurrentBusinessModelChange} // GRL_MODIFY: correct value prop
        {...getOverrideProps(overrides, "CurrentBusinessModelChange")}
      ></TextAreaField>
      <TextAreaField
        label="Anticipated business model change"
        isRequired={false}
        isReadOnly={false}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              CurrentBusinessModelChange,
              AnticipatedBusinessModelChange: value,
            };
            const result = onChange(modelFields);
            value = result?.AnticipatedBusinessModelChange ?? value;
          }
          if (errors.AnticipatedBusinessModelChange?.hasError) {
            runValidationTasks("AnticipatedBusinessModelChange", value);
          }
          setAnticipatedBusinessModelChange(value);
        }}
        onBlur={() =>
          runValidationTasks(
            "AnticipatedBusinessModelChange",
            AnticipatedBusinessModelChange
          )
        }
        errorMessage={errors.AnticipatedBusinessModelChange?.errorMessage}
        hasError={errors.AnticipatedBusinessModelChange?.hasError}
        	value={AnticipatedBusinessModelChange} // GRL_MODIFY: correct value prop
        {...getOverrideProps(overrides, "AnticipatedBusinessModelChange")}
      ></TextAreaField>
      <Divider
        orientation="horizontal"
        {...getOverrideProps(overrides, "SectionalElement3")}
      ></Divider>
      <Flex
        justifyContent="space-between"
        {...getOverrideProps(overrides, "CTAFlex")}
      >
        <Button
          children="Clear"
          type="reset"
          onClick={(event) => {
            event.preventDefault();
            resetStateValues();
          }}
          {...getOverrideProps(overrides, "ClearButton")}
        ></Button>
        <Flex
          gap="15px"
          {...getOverrideProps(overrides, "RightAlignCTASubFlex")}
        >
          <Button
            children="Submit"
            type="submit"
            variation="primary"
            isDisabled={Object.values(errors).some((e) => e?.hasError)}
            {...getOverrideProps(overrides, "SubmitButton")}
          ></Button>
        </Flex>
      </Flex>
    </Grid>
  );
}
